<template>
  <b-modal
    ref="bModal"
    :title="$t('shipments.modal.addressBook')"
    centered
    modal-class="address-book"
  >
    <b-row class="py-3 px-4">
      <b-col
        cols="12"
        class="d-flex flex-column"
      >
        <vt-grid
          pagination
          class="address-book-grid"
          :grid-options="gridOptions"
          :row-data="rowData"
          :column-defs="columnDefs"
        />
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-5 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-7 text-right">
          <!-- TODO: Borrar y compartir/descompartir solo aplican para tus propias plantillas -->
          <b-button
            v-if="selectedRows.length >= 1"
            size="sm"
            class="btn__outline mr-2"
          >
            <i
              class="fal fa-share-alt mr-2"
              aria-hidden="true"
            />
            {{ $t('shipments.modal.share') }}
          </b-button>
          <!-- TODO: Dejar de compartir aparecerá en casos de seleccionar uno o más registro que tengan el check de compartir a True -->
          <!--<b-button v-if="selectedRows.length >= 1" size="sm" class="btn__outline mr-2">
                        <i class="fal fa-undo mr-2" aria-hidden="true"></i>
                        {{ $t('shipments.modal.undoShare') }}
                    </b-button>-->
          <b-button
            v-if="selectedRows.length === 1"
            size="sm"
            class="btn__outline mr-2"
          >
            <i
              class="fal fa-trash-alt mr-2"
              aria-hidden="true"
            />
            {{ $t('global.delete') }}
          </b-button>
          <b-button
            v-if="selectedRows.length === 1"
            size="sm"
            class="btn--primary"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('global.apply') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import VtGrid from '@/components/VtGrid/VtGrid'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import i18n from '@/lang/i18n'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'AddressBook',
    components: {
        VtGrid
    },
    data() {
        return {
            isActive: false,
            selected: null,
            selectedRows: [],
            columnDefs: [
                { type: 'suppressAll', checkboxSelection: true, hide: false, minWidth: 60, pinned: 'left' },
                {
                    type: 'text',
                    headerName: i18n.t('shipments.modal.author'),
                    colId: 'author',
                    field: 'author',
                    width: 150,
                    minWidth: 140,
                    suppressSizeToFit: true
                },
                {
                    type: 'checkIconRenderer',
                    headerName: i18n.t('shipments.modal.shared'),
                    colId: 'shared',
                    field: 'shared',
                    width: 150,
                    minWidth: 140,
                    suppressSizeToFit: true
                },
                {
                    type: 'text',
                    headerName: i18n.t('shipments.modal.centerName'),
                    colId: 'centerName',
                    field: 'centerName',
                    width: 150,
                    minWidth: 140,
                    suppressSizeToFit: true
                },
                {
                    type: 'text',
                    headerName: i18n.t('shipments.modal.address'),
                    colId: 'centerAddress',
                    field: 'centerAddress',
                    width: 150,
                    minWidth: 280,
                    suppressSizeToFit: true
                },
                {
                    type: 'text',
                    headerName: i18n.t('shipments.modal.postalCode'),
                    colId: 'centerPostalCode',
                    field: 'centerPostalCode',
                    flex: 1,
                    width: 200,
                    minWidth: 100,
                    suppressSizeToFit: true
                },
                {
                    type: 'text',
                    headerName: i18n.t('shipments.modal.province'),
                    colId: 'centerProvince',
                    field: 'centerProvince',
                    flex: 1,
                    width: 200,
                    minWidth: 100,
                    suppressSizeToFit: true
                },
                {
                    type: 'text',
                    headerName: i18n.t('shipments.modal.country'),
                    colId: 'centerCountry',
                    field: 'centerCountry',
                    flex: 1,
                    width: 200,
                    minWidth: 100,
                    suppressSizeToFit: true
                },
                {
                    type: 'text',
                    headerName: i18n.t('shipments.modal.contactTelephone'),
                    colId: 'centerTelephone',
                    field: 'centerTelephone',
                    flex: 1,
                    width: 200,
                    minWidth: 100,
                    suppressSizeToFit: true
                }
            ],
            rowData: [
                {
                    author: 'Francisco Jiménez',
                    shared: true,
                    centerName: 'Nombre centro',
                    centerAddress: 'Lorem ipsum dolor',
                    centerPostalCode: '00000',
                    centerProvince: 'Provincia',
                    centerCountry: 'País',
                    centerPhone: '0000000'
                },
                {
                    author: 'Francisco Jiménez',
                    shared: false,
                    centerName: 'Nombre centro',
                    centerAddress: 'Lorem ipsum dolor',
                    centerPostalCode: '00000',
                    centerProvince: 'Provincia',
                    centerCountry: 'País',
                    centerPhone: '0000000'
                },
                {
                    author: 'Francisco Jiménez',
                    shared: false,
                    centerName: 'Nombre centro',
                    centerAddress: 'Lorem ipsum dolor',
                    centerPostalCode: '00000',
                    centerProvince: 'Provincia',
                    centerCountry: 'País',
                    centerPhone: '0000000'
                },
                {
                    author: 'Francisco Jiménez',
                    shared: false,
                    centerName: 'Nombre centro',
                    centerAddress: 'Lorem ipsum dolor',
                    centerPostalCode: '00000',
                    centerProvince: 'Provincia',
                    centerCountry: 'País',
                    centerPhone: '0000000'
                }
            ]
        }
    },
    computed: {
        gridOptions() {
            return {
                sideBar: gridSideBarConfig,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                getContextMenuItems: this.getContextMenuItems,
                onGridReady: this.onGridReady,
                onSelectionChanged: this.onSelectionChanged
            }
        }
    },
    methods: {
        show() {
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        getContextMenuItems(params) {
            // TODO: Tener en cuenta el mismo funcionamiento de los botones de la modal para las opciones del menú contextual
            return [
                {
                    name: this.$t('shipments.modal.share'),
                    cssClasses: this.selectedRows.length === 1 ? ['not-show'] : ''
                },
                {
                    name: this.$t('global.delete'),
                    cssClasses: this.selectedRows.length === 1 ? ['not-show'] : ''
                },
                {
                    name: this.$t('global.apply'),
                    cssClasses: this.selectedRows.length > 1 ? ['not-show'] : ''
                }
            ]
        },
        onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()
        },
        onGridReady({ api }) {
            this.gridApi = api
        }
    }
}

</script>

<style lang="scss">
    .address-book .modal-body {
        padding: 0;
    }

    .address-book .address-book-grid {
        height: calc(100vh - 550px);
    }

    @media (max-width: 1300px) {
        .address-book .modal-dialog {
            max-width: 25%;
        }
    }
</style>

<style lang="scss" scoped>
    .address-book span {
        font-size: font-size(very-normal);
    }
</style>
